import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import DisplayMethod from '@/components/Widget/DisplayMethod';

import ChatbotAvatar from './ChatbotAvatar';
import ChatbotIcon from './ChatbotIcon';
import { GeneralBrand } from './GeneralBrand';
import { GeneralColor } from './GeneralColor';
import { GeneralText } from './GeneralText';
import { GroupSection } from './GroupSection';
import { ShareGuide } from './ShareGuide';
import { SecurityNotice } from './SecurityNotice';
import { WidgetAutoOpen } from './WidgetAutoOpen';
import { WidgetTitleBar } from './WidgetTitleBar';

export default () => {
  const { t } = useTranslation();

  return (
    <Stack mb={40} gap={28} className="select-none">
      {/* L1 通用设置：小部件 + 纯聊天分享页都生效 */}
      <GroupSection title={t('widget.setting.groups.general_title')} desc={t('widget.setting.groups.general_desc')}>
        <ChatbotAvatar />
        <GeneralText />
        <GeneralColor />
        <GeneralBrand />
        <SecurityNotice />
      </GroupSection>

      {/* L1 小部件专属：仅嵌入小窗 / 全屏小部件生效 */}
      <GroupSection
        title={t('widget.setting.groups.widget_only_title')}
        desc={t('widget.setting.groups.widget_only_desc')}
      >
        <ChatbotIcon />
        <WidgetTitleBar />
        <WidgetAutoOpen />
      </GroupSection>

      {/* L1 纯聊天分享专属：仅 /bot 纯聊天分享页生效 */}
      <GroupSection
        title={t('widget.setting.groups.share_only_title')}
        desc={t('widget.setting.groups.share_only_desc')}
      >
        <ShareGuide />
      </GroupSection>

      <DisplayMethod />
    </Stack>
  );
};
